import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { PostMessageTypesEnum } from './app/enums/post-message-type.enum';
import { isExpectedHttpError } from './app/utils/http-error.util';
import { environment } from './environments/environment';

if (environment.sentry.enabled) {
  Sentry.init({
    dsn: environment.sentry.dsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.httpClientIntegration()
    ],
    tracesSampleRate: 0.1,
    // Satellite tiles load in parallel by design, triggering false N+1 issues.
    ignoreSpans: [
      {
        op: /^http\.client$/,
        name: /^GET https:\/\/api\.mapbox\.com\/v4\/mapbox\.satellite\/\d+\/\d+\/\d+(?:@2x)?\.webp(?:\?|$)/
      }
    ],
    debug: environment.sentry.debug,
    environment: environment.name,
    beforeSend: (event, hint) =>
      isExpectedHttpError(hint.originalException) ? null : event
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    if (window.parent !== window) {
      window.parent.postMessage(
        { type: PostMessageTypesEnum.IFRAME_READY },
        '*'
      );
    }
  })
  // eslint-disable-next-line no-console
  .catch((err: unknown) => console.error(err));
